export const TOOL_STATUS = {
  active: 'active',
  complete: 'complete',
  failed: 'failed',
  neverActive: 'neverActive',
  paused: 'paused',
  warning: 'warning',
} as const;
